const regionRows = [
  ['forehead', 'Testa', 'Forehead', 'Frente'],
  ['glabella', 'Glabela', 'Glabella', 'Glabela'],
  ['temple-l', 'Têmpora', 'Temple', 'Sien'],
  ['temple-r', 'Têmpora', 'Temple', 'Sien'],
  ['periocular-l', 'Periorbital', 'Periocular', 'Periorbitario'],
  ['periocular-r', 'Periorbital', 'Periocular', 'Periorbitario'],
  ['tear-l', 'Olheira', 'Tear trough', 'Ojeras'],
  ['tear-r', 'Olheira', 'Tear trough', 'Ojeras'],
  ['nose', 'Nariz', 'Nose', 'Nariz'],
  ['malar-l', 'Malar', 'Malar', 'Malar'],
  ['malar-r', 'Malar', 'Malar', 'Malar'],
  ['nasolabial-l', 'Sulco nasolabial', 'Nasolabial fold', 'Surco nasolabial'],
  ['nasolabial-r', 'Sulco nasolabial', 'Nasolabial fold', 'Surco nasolabial'],
  ['lips', 'Lábios', 'Lips', 'Labios'],
  ['chin', 'Mento', 'Chin', 'Mentón'],
  ['prejowl-l', 'Pré-jowl', 'Prejowl', 'Prejowl'],
  ['prejowl-r', 'Pré-jowl', 'Prejowl', 'Prejowl'],
  ['jaw-l', 'Mandíbula', 'Jaw', 'Mandíbula'],
  ['jaw-r', 'Mandíbula', 'Jaw', 'Mandíbula'],
  ['m-frontalis', 'Frontal', 'Frontalis', 'Frontal'],
  ['m-corrugator-l', 'Corrugador', 'Corrugator', 'Corrugador'],
  ['m-corrugator-r', 'Corrugador', 'Corrugator', 'Corrugador'],
  ['m-procerus', 'Prócero', 'Procerus', 'Prócer'],
  ['m-orb-oculi-l', 'Orbicular do olho', 'Orbicularis oculi', 'Orbicular del ojo'],
  ['m-orb-oculi-r', 'Orbicular do olho', 'Orbicularis oculi', 'Orbicular del ojo'],
  ['m-temporalis-l', 'Temporal', 'Temporalis', 'Temporal'],
  ['m-temporalis-r', 'Temporal', 'Temporalis', 'Temporal'],
  ['m-nasalis', 'Nasal', 'Nasalis', 'Nasal'],
  ['m-zygomatic-l', 'Zigomático', 'Zygomaticus', 'Cigomático'],
  ['m-zygomatic-r', 'Zigomático', 'Zygomaticus', 'Cigomático'],
  ['m-masseter-l', 'Masseter', 'Masseter', 'Masetero'],
  ['m-masseter-r', 'Masseter', 'Masseter', 'Masetero'],
  ['m-orb-oris', 'Orbicular da boca', 'Orbicularis oris', 'Orbicular de la boca'],
  ['m-dao-l', 'DAO', 'DAO', 'DAO'],
  ['m-dao-r', 'DAO', 'DAO', 'DAO'],
  ['m-mentalis', 'Mentual', 'Mentalis', 'Mentoniano'],
  ['m-platysma-l', 'Platisma', 'Platysma', 'Platisma'],
  ['m-platysma-r', 'Platisma', 'Platysma', 'Platisma'],
  ['n-v1-l', 'V1 supraorbital', 'V1 supraorbital', 'V1 supraorbitario'],
  ['n-v1-r', 'V1 supraorbital', 'V1 supraorbital', 'V1 supraorbitario'],
  ['n-v2-l', 'V2 infraorbital', 'V2 infraorbital', 'V2 infraorbitario'],
  ['n-v2-r', 'V2 infraorbital', 'V2 infraorbital', 'V2 infraorbitario'],
  ['n-v3-l', 'V3 mentoniano', 'V3 mental', 'V3 mentoniano'],
  ['n-v3-r', 'V3 mentoniano', 'V3 mental', 'V3 mentoniano'],
  ['n-vii-trunk-l', 'VII tronco (parótida)', 'VII trunk (parotid)', 'VII tronco (parótida)'],
  ['n-vii-trunk-r', 'VII tronco (parótida)', 'VII trunk (parotid)', 'VII tronco (parótida)'],
  ['n-vii-temporal-l', 'VII temporal', 'VII temporal', 'VII temporal'],
  ['n-vii-temporal-r', 'VII temporal', 'VII temporal', 'VII temporal'],
  ['n-vii-zygomatic-l', 'VII zigomático', 'VII zygomatic', 'VII cigomático'],
  ['n-vii-zygomatic-r', 'VII zigomático', 'VII zygomatic', 'VII cigomático'],
  ['n-vii-buccal-l', 'VII bucal', 'VII buccal', 'VII bucal'],
  ['n-vii-buccal-r', 'VII bucal', 'VII buccal', 'VII bucal'],
  ['n-vii-mandibular-l', 'VII mandibular', 'VII mandibular', 'VII mandibular'],
  ['n-vii-mandibular-r', 'VII mandibular', 'VII mandibular', 'VII mandibular'],
  ['n-vii-cervical-l', 'VII cervical', 'VII cervical', 'VII cervical'],
  ['n-vii-cervical-r', 'VII cervical', 'VII cervical', 'VII cervical'],
  ['n-danger-angular', 'Artéria angular (risco)', 'Angular artery (risk)', 'Arteria angular (riesgo)'],
  ['n-danger-facial-l', 'Artéria facial (risco)', 'Facial artery (risk)', 'Arteria facial (riesgo)'],
  ['n-danger-facial-r', 'Artéria facial (risco)', 'Facial artery (risk)', 'Arteria facial (riesgo)']
];

const conditionRows = [
  ['healthy', 'Saudável / limpar', 'Healthy / clear', 'Sano / limpiar'],
  ['caries', 'Cárie', 'Caries', 'Caries'],
  ['restoration', 'Restauração', 'Restoration', 'Restauración'],
  ['endo', 'Canal', 'Root canal', 'Endodoncia'],
  ['crown', 'Coroa', 'Crown', 'Corona'],
  ['implant', 'Implante', 'Implant', 'Implante'],
  ['sealant', 'Selante', 'Sealant', 'Sellador'],
  ['extraction', 'Extração indicada', 'Extraction indicated', 'Extracción indicada'],
  ['extracted', 'Ausente / extraído', 'Missing / extracted', 'Ausente / extraído'],
  ['supragingival_scaling', 'Raspagem supragengival', 'Supragingival scaling', 'Raspado supragingival'],
  ['subgingival_scaling', 'Raspagem subgengival', 'Subgingival scaling', 'Raspado subgingival'],
  ['prophylaxis', 'Profilaxia', 'Prophylaxis', 'Profilaxis'],
  ['removable_prosthesis', 'Prótese removível', 'Removable prosthesis', 'Prótesis removible'],
  ['denture', 'Dentadura', 'Denture', 'Dentadura'],
  ['implant_prosthesis', 'Prótese sobre implante', 'Implant prosthesis', 'Prótesis sobre implante'],
  ['watch', 'Observação', 'Watch', 'Observación']
];

const surfaceRows = [
  ['V', 'Vestibular', 'Buccal', 'Vestibular'],
  ['M', 'Mesial', 'Mesial', 'Mesial'],
  ['D', 'Distal', 'Distal', 'Distal'],
  ['O', 'Oclusal', 'Occlusal', 'Oclusal'],
  ['I', 'Incisal', 'Incisal', 'Incisal'],
  ['L', 'Lingual', 'Lingual', 'Lingual'],
  ['P', 'Palatina', 'Palatal', 'Palatina']
];

const sextantRows = [
  ['S1', 'S1', 'Maxila posterior direita', 'Right posterior maxilla', 'Maxilar posterior derecho'],
  ['S2', 'S2', 'Maxila anterior', 'Anterior maxilla', 'Maxilar anterior'],
  ['S3', 'S3', 'Maxila posterior esquerda', 'Left posterior maxilla', 'Maxilar posterior izquierdo'],
  ['S4', 'S4', 'Mandíbula posterior esquerda', 'Left posterior mandible', 'Mandíbula posterior izquierda'],
  ['S5', 'S5', 'Mandíbula anterior', 'Anterior mandible', 'Mandíbula anterior'],
  ['S6', 'S6', 'Mandíbula posterior direita', 'Right posterior mandible', 'Mandíbula posterior derecha']
];

function pick(rows, index) {
  return Object.fromEntries(rows.map((row) => [row[0], row[index]]));
}

const phrasesEn = {
  'Fixo metálico': 'Metal fixed appliance',
  'Fixo estético (cerâmico/safira)': 'Aesthetic fixed (ceramic/sapphire)',
  Autoligado: 'Self-ligating',
  'Alinhadores transparentes': 'Clear aligners',
  'Aparelho móvel': 'Removable appliance',
  'Ortopedia funcional': 'Functional orthopedics',
  Contenção: 'Retainer',
  'Fio NiTi 0,012': 'NiTi wire 0.012',
  'Fio NiTi 0,014': 'NiTi wire 0.014',
  'Fio NiTi 0,016': 'NiTi wire 0.016',
  'Fio NiTi 0,018': 'NiTi wire 0.018',
  'Fio NiTi 0,016 x 0,022': 'NiTi wire 0.016 x 0.022',
  'Fio aço 0,018': 'Steel wire 0.018',
  'Fio aço 0,019 x 0,025': 'Steel wire 0.019 x 0.025',
  'Fio TMA': 'TMA wire',
  'Sem arco instalado': 'No archwire',
  Botox: 'Botox',
  'Botox Fullface': 'Full-face Botox',
  'Preenchimento labial': 'Lip filler',
  'Preenchimento de olheiras': 'Tear trough filler',
  'Preenchimento de malar': 'Malar filler',
  'Preenchimento de mandíbula': 'Jaw filler',
  'Preenchimento de mento e pré-jowls': 'Chin and prejowl filler',
  'Preenchimento bigode chinês': 'Nasolabial filler',
  Microagulhamento: 'Microneedling',
  'Bioestimulador de colágeno': 'Collagen biostimulator',
  'Fio de PDO liso': 'Smooth PDO thread',
  'Limpeza de pele': 'Facial cleansing',
  'Toxina botulínica': 'Botulinum toxin',
  Preenchimento: 'Filler',
  Bioestimulador: 'Biostimulator',
  'Fio de PDO': 'PDO thread',
  'Zona de risco / observação': 'Risk zone / note'
};

const phrasesEs = {
  'Fixo metálico': 'Fijo metálico',
  'Fixo estético (cerâmico/safira)': 'Fijo estético (cerámica/zafiro)',
  Autoligado: 'Autoligado',
  'Alinhadores transparentes': 'Alineadores transparentes',
  'Aparelho móvel': 'Aparato removible',
  'Ortopedia funcional': 'Ortopedia funcional',
  Contenção: 'Contención',
  'Fio NiTi 0,012': 'Arco NiTi 0,012',
  'Fio NiTi 0,014': 'Arco NiTi 0,014',
  'Fio NiTi 0,016': 'Arco NiTi 0,016',
  'Fio NiTi 0,018': 'Arco NiTi 0,018',
  'Fio NiTi 0,016 x 0,022': 'Arco NiTi 0,016 x 0,022',
  'Fio aço 0,018': 'Arco de acero 0,018',
  'Fio aço 0,019 x 0,025': 'Arco de acero 0,019 x 0,025',
  'Fio TMA': 'Arco TMA',
  'Sem arco instalado': 'Sin arco instalado',
  Botox: 'Botox',
  'Botox Fullface': 'Botox full face',
  'Preenchimento labial': 'Relleno labial',
  'Preenchimento de olheiras': 'Relleno de ojeras',
  'Preenchimento de malar': 'Relleno de malar',
  'Preenchimento de mandíbula': 'Relleno de mandíbula',
  'Preenchimento de mento e pré-jowls': 'Relleno de mentón y prejowl',
  'Preenchimento bigode chinês': 'Relleno de surco nasolabial',
  Microagulhamento: 'Microagujas',
  'Bioestimulador de colágeno': 'Bioestimulador de colágeno',
  'Fio de PDO liso': 'Hilo de PDO liso',
  'Limpeza de pele': 'Limpieza facial',
  'Toxina botulínica': 'Toxina botulínica',
  Preenchimento: 'Relleno',
  Bioestimulador: 'Bioestimulador',
  'Fio de PDO': 'Hilo de PDO',
  'Zona de risco / observação': 'Zona de riesgo / observación'
};

export function phraseLabel(locale, value) {
  if (!value) return '';
  const map = locale === 'en' ? phrasesEn : locale === 'es' ? phrasesEs : null;
  return (map && map[value]) || value;
}

const shell = (index) => ({
  hofRegions: pick(regionRows, index + 1),
  odoConditions: pick(conditionRows, index + 1),
  odoSurfaces: pick(surfaceRows, index + 1),
  odoSextants: Object.fromEntries(sextantRows.map((row) => [row[0], row[index + 2]]))
});

const morePt = {
  ...shell(0),
  anamnesis: {
    healthConditions: 'Condições de saúde',
    healthConditionsHint: 'Ex.: hipertensão, diabetes, gestação...',
    allergies: 'Alergias',
    allergiesHint: 'Medicamentos, látex, anestésicos...',
    medications: 'Medicamentos em uso',
    medicationsHint: 'Nome, dose e frequência',
    chiefComplaint: 'Queixa principal',
    chiefComplaintHint: 'Motivo da consulta nas palavras do paciente'
  },
  overview: {
    incompleteTitle: 'Cadastro incompleto',
    incompleteBody: 'complete os dados antes de registrar novos atendimentos. Informação não registrada não significa ausência de condição clínica.',
    identity: 'Identificação e contato',
    completeRegistration: 'Completar cadastro',
    editRegistration: 'Editar cadastro',
    name: 'Nome',
    birthAge: 'Data de nascimento / idade',
    document: 'CPF / documento',
    phone: 'Telefone',
    email: 'E-mail',
    address: 'Endereço',
    card: 'Carteirinha',
    pendingLine: 'Pendente no cadastro: {items}.',
    pendingBirth: 'data de nascimento',
    pendingCpf: 'CPF',
    pendingPhone: 'telefone',
    pendingEmail: 'e-mail',
    pendingAddress: 'endereço',
    invalidDate: 'Data inválida',
    age: '{age} anos',
    anamnesis: 'Anamnese',
    registerAnamnesis: 'Registrar anamnese',
    editAnamnesis: 'Editar anamnese',
    cancel: 'Cancelar',
    saving: 'Salvando...',
    saveAnamnesis: 'Salvar anamnese',
    anamnesisEmpty: 'Nenhuma anamnese registrada. Informação não registrada não significa ausência de condição de saúde, alergia ou medicamento.',
    notesTitle: 'Observações do paciente',
    addNote: 'Adicionar observação',
    newNote: 'Nova observação',
    notePlaceholder: 'Evolução, conduta, orientações e observações do atendimento...',
    noNotes: 'Nenhuma observação disponível.',
    noNotesBody: 'Registre orientações e informações relevantes para o acompanhamento.',
    registrationNote: 'Observação do cadastro',
    team: 'Equipe',
    history: 'Consultas e histórico',
    registerVisit: 'Registrar Consulta',
    loadingHistory: 'Carregando histórico...',
    noHistory: 'Histórico de consultas não informado.',
    noHistoryHof: 'Os registros HOF ao lado não confirmam uma consulta realizada. Registre o atendimento para vincular o histórico.',
    noHistoryBody: 'Registre o atendimento para iniciar o histórico deste paciente.',
    visitFallback: 'Consulta',
    dateUnavailable: 'Data não disponível',
    professionalUnknown: 'Profissional não informado',
    showing: 'Mostrando {shown} de {total} consultas.',
    hofTitle: 'Registros HOF',
    viewHof: 'Ver HOF',
    noHof: 'Nenhum registro HOF no prontuário.',
    hofCount: '{count} {word} no prontuário',
    recordOne: 'registro',
    recordMany: 'registros',
    hofMore: 'e mais {count} no mapa HOF.',
    hofNoPhoto: 'Registros preservados sem foto do paciente: as posições na imagem ainda não foram definidas.',
    sections: 'Seções do prontuário',
    odontogram: 'Odontograma',
    media: 'Mídias',
    loadingMedia: 'Carregando mídias...',
    noMedia: 'Nenhuma mídia enviada',
    fileOne: 'arquivo',
    fileMany: 'arquivos',
    orthoMedia: 'ortodôntica',
    orthoMediaMany: 'ortodônticas',
    toothOne: 'dente',
    toothMany: 'dentes',
    odoSummary: '{teeth} {toothWord} com achado · {records} {recordWord}',
    odoEmpty: 'Avaliação odontológica não registrada',
    hofIllustration: 'A ilustração facial do mapa HOF é referência anatômica e não representa o paciente. Use uma foto autorizada na aba HOF para posicionar as marcações.',
    footer: 'Mantenha o prontuário atualizado com informações confirmadas pelo paciente e registros do profissional.',
    notInformed: 'Não informado',
    historyError: 'Erro ao carregar histórico de consultas',
    anamnesisSaved: 'Anamnese registrada',
    anamnesisError: 'Erro ao salvar anamnese',
    noteRequired: 'Escreva a observação',
    noteSaved: 'Observação adicionada',
    noteError: 'Erro ao salvar observação'
  },
  patientForm: {
    editTitle: 'Editar Paciente',
    newTitle: 'Novo Paciente',
    editSubtitle: 'Atualize as informações do paciente',
    newSubtitle: 'Preencha as informações do novo paciente',
    fullName: 'Nome Completo *',
    nameRequired: 'Nome é obrigatório',
    namePlaceholder: 'Nome completo do paciente',
    email: 'Email',
    emailPlaceholder: 'email@exemplo.com',
    phone: 'Telefone *',
    phoneRequired: 'Telefone é obrigatório',
    phoneInvalid: 'Informe um telefone válido: (99) 9999-9999 ou (99) 99999-9999',
    cpf: 'CPF',
    cpfInvalid: 'CPF inválido',
    card: 'Número da carteirinha',
    cardPlaceholder: 'Número do convênio/plano',
    birth: 'Data de Nascimento',
    address: 'Endereço',
    addressPlaceholder: 'Endereço completo',
    notes: 'Observações',
    notesPlaceholder: 'Observações sobre o paciente...',
    active: 'Paciente ativo',
    cancel: 'Cancelar',
    saving: 'Salvando...',
    update: 'Atualizar',
    create: 'Criar',
    updated: 'Paciente atualizado com sucesso!',
    created: 'Paciente criado com sucesso!',
    saveError: 'Erro ao salvar paciente',
    missingClinic: 'ID da clínica não encontrado'
  },
  autocomplete: {
    placeholder: 'Digite ao menos 2 letras para buscar',
    clear: 'Limpar',
    noContact: 'Sem contato',
    minChars: 'Digite pelo menos {count} caracteres para buscar',
    none: 'Nenhum paciente encontrado para “{query}”'
  },
  odo: {
    title: 'Odontograma',
    subtitle: 'Dentição {dentition} · selecione um dente para iniciar um registro.',
    history: 'Histórico',
    historyTitle: 'Histórico do odontograma',
    historyEmpty: 'Nenhum registro adicionado ao odontograma.',
    dentition: 'Dentição',
    permanent: 'Permanente',
    deciduous: 'Decídua',
    notation: 'Notação FDI · {count} posições',
    generalNotes: 'Observações gerais do odontograma',
    generalPlaceholder: 'Registre observações após a avaliação odontológica...',
    selection: 'Seleção para registrar',
    selectionTooth: 'Seleção para registrar · Dente {tooth}',
    selectionRegion: 'Seleção para registrar · {regions}',
    regionOnly: 'Região da raspagem, sem dente específico.',
    noneSelected: 'Nenhum dente selecionado.',
    toothOrRegion: 'Dente ou região',
    selectTooth: 'Selecionar dente...',
    toothOption: 'Dente {tooth}',
    toothSelected: 'Dente {tooth} · seleção visual',
    region: 'Região',
    regionHint: 'Marque uma ou mais regiões da raspagem.',
    surface: 'Face / superfície',
    surfaceHint: 'Selecione um dente para ver as faces.',
    condition: 'Condição / achado clínico',
    recordNotes: 'Observação do registro',
    recordPlaceholder: 'Material, conduta, descrição do achado...',
    addHintTooth: 'O registro entra no histórico do dente e atualiza o mapa após a confirmação do profissional.',
    addHintRegion: 'O registro entra no histórico da região. O mapa dos dentes permanece sem essa marcação.',
    addHintEmpty: 'Selecione o dente ou uma ou mais regiões e a condição, como a raspagem.',
    add: 'Adicionar registro',
    toothHistory: 'Histórico do dente {tooth}',
    regionHistory: 'Histórico das regiões',
    toothHistoryEmpty: 'Histórico do dente',
    clearMap: 'Remover achado do mapa',
    pickTooth: 'Selecione um dente',
    pickToothBody: 'Os registros de cada posição aparecem aqui. Regiões da raspagem ficam neste histórico.',
    noRecord: 'Registro não disponível',
    noRecordBody: 'Nenhuma informação odontológica fornecida para esta posição.',
    dirty: 'Alterações ainda não salvas no prontuário.',
    saved: 'Odontograma salvo no prontuário.',
    clearSelection: 'Limpar seleção',
    saving: 'Salvando...',
    save: 'Salvar odontograma',
    footnote: 'O diagrama é uma representação esquemática. Dentes neutros não representam dentes saudáveis.',
    added: 'Registro adicionado em {target}. Salve o odontograma para confirmar.',
    toothTarget: 'dente {tooth}',
    saveOk: 'Odontograma atualizado no prontuário',
    saveError: 'Erro ao salvar odontograma',
    team: 'Equipe',
    states: 'Estados',
    unevaluated: 'Não avaliado',
    selectedToRecord: 'Selecionado para registrar',
    withRecord: 'Com registro',
    maxilla: 'MAXILA',
    mandible: 'MANDÍBULA',
    patientRight: 'D - direito do paciente',
    patientLeft: 'E - esquerdo do paciente',
    archMaxilla: 'Maxila',
    archMandible: 'Mandíbula',
    sideRight: 'lado direito do paciente',
    sideLeft: 'lado esquerdo do paciente',
    toothStateSelected: 'selecionado',
    toothStateRecorded: 'com registro',
    toothStateNone: 'não avaliado',
    toothAria: 'Dente {tooth}, {state}',
    legacyO: 'Oclusal / Incisal',
    legacyL: 'Lingual / Palatina'
  },
  ortho: {
    title: 'Ortodontia',
    subtitle: 'Acompanhamento e registro de manutenções do aparelho',
    evolution: 'Evolução Ortodôntica',
    evolutionBody: 'Histórico de consultas, fios utilizados e ativações do aparelho',
    empty: 'Nenhuma manutenção registrada.',
    emptyBody: 'Use o formulário ao lado para iniciar o histórico ortodôntico deste paciente.',
    recordOne: 'registro',
    recordMany: 'registros',
    newest: 'Mais recente primeiro',
    noDate: 'Sem data',
    team: 'Equipe',
    applianceUnknown: 'Aparelho não informado',
    upper: 'Superiores',
    lower: 'Inferiores',
    procedure: 'Procedimento Realizado',
    hygiene: 'Higiene {label}',
    hygieneUnknown: 'Higiene não avaliada',
    register: 'Registrar Manutenção',
    registerBody: 'Insira os dados da ativação realizada hoje',
    appliance: 'Tipo de Aparelho',
    selectAppliance: 'Selecionar aparelho…',
    upperArch: 'Arco Superior',
    lowerArch: 'Arco Inferior',
    select: 'Selecionar…',
    conduct: 'Conduta / Ativação',
    conductPlaceholder: 'Descreva amarrios, molas, elásticos e demais condutas…',
    oralHygiene: 'Higiene Bucal do Paciente',
    hygieneGroup: 'Higiene bucal do paciente',
    hygieneLine: 'Higiene {label}.',
    hygieneNone: 'Não avaliada · nenhuma opção selecionada',
    note: 'Preencha somente informações verificadas no atendimento. Os campos estão sem dados clínicos.',
    saving: 'Registrando...',
    confirm: 'Confirmar evolução',
    photos: 'Fotos de Controle Ortodôntico',
    photosHint: 'Na aba Mídias · filtro Fotos ortodônticas',
    viewPhotos: 'Ver fotos e comparar Antes/Depois',
    footer: 'Mantenha o prontuário atualizado com informações confirmadas pelo paciente e registros do profissional.',
    saved: 'Evolução ortodôntica registrada',
    saveError: 'Erro ao registrar evolução',
    hygieneExcelente: 'Excelente',
    hygieneRegular: 'Regular',
    hygieneRuim: 'Ruim'
  },
  media: {
    title: 'Mídias',
    subtitle: 'Fotos, exames e documentos do prontuário, organizados por seção.',
    uploading: 'Enviando...',
    upload: 'Enviar arquivos',
    locked: 'Anexos de mídia não estão disponíveis no plano atual. Os arquivos existentes continuam visíveis.',
    filters: 'Filtros de mídia',
    all: 'Todos',
    images: 'Imagens',
    exams: 'Exames',
    documents: 'Documentos',
    orthoPhotos: 'Fotos ortodônticas',
    dropOrtho: 'Arraste fotos ortodônticas aqui',
    dropFiles: 'Arraste arquivos aqui',
    dropOrthoHint: 'JPG ou PNG · organizadas na seção Ortodontia',
    dropHint: 'Imagens, PDF ou MP4 · até 15 MB · seção {section}',
    select: 'Selecionar',
    loading: 'Carregando mídias...',
    emptySuffix: ' - nenhum arquivo clínico fornecido',
    emptyOrtho: 'Nenhuma foto ortodôntica',
    emptyFilter: 'Nenhuma mídia neste filtro',
    emptyOrthoBody: 'As fotos de controle adicionadas na aba Mídias e organizadas em Ortodontia aparecem aqui para comparação.',
    emptyFilterBody: 'Envie fotos, exames ou documentos para organizar o prontuário.',
    compare: 'Comparar antes / depois',
    base: 'Base - antes',
    overlay: 'Sobreposta - depois',
    selectPhoto: 'Selecionar foto...',
    opacity: 'Opacidade da sobreposta',
    before: 'Antes',
    after: 'Depois',
    needImage: 'Envie ao menos uma imagem para visualizar.',
    pickPreview: 'Selecione uma foto para visualizar. A segunda fica sobreposta.',
    details: 'Detalhes da imagem',
    noneSelected: 'Nenhuma foto selecionada',
    section: 'Seção de organização',
    caption: 'Descrição / observação',
    captionPlaceholder: 'Contexto, data do registro, autorização do paciente...',
    saving: 'Salvando...',
    saveOrg: 'Salvar organização',
    noPhotoYet: 'Nenhuma foto foi fornecida para este paciente ainda.',
    pickFile: 'Selecione um arquivo na galeria para editar a seção e a descrição.',
    planError: 'Anexos de mídia não estão disponíveis neste plano',
    uploadedOne: 'Arquivo enviado',
    uploadedMany: '{count} arquivos enviados',
    removed: 'Arquivo removido',
    removeNamed: 'Remover "{name}"?',
    removeHofPhoto: 'Remover "{name}"? Esta imagem é a foto do paciente no mapa HOF.',
    removeHofResult: 'Remover "{name}"? Esta imagem é a foto de resultado do mapa HOF.',
    removeError: 'Erro ao remover',
    orgSaved: 'Organização salva',
    orgError: 'Erro ao salvar organização',
    orthoCountOne: 'foto ortodôntica',
    orthoCountMany: 'fotos ortodônticas',
    team: 'Equipe',
    preserve: 'Preserve a autorização e o contexto de cada arquivo do prontuário.',
    open: 'Abrir',
    remove: 'Remover',
    close: 'Fechar',
    storage: 'Armazenamento: {used} / {quota} ({plan}/clínica)',
    orthoType: '{name}: use JPG ou PNG nas fotos ortodônticas',
    uploadFail: 'falha no envio',
    selectNamed: 'Selecionar {name}',
    sectionClinical: 'Clínica',
    sectionExam: 'Exames',
    sectionDocument: 'Documentos',
    sectionOrtho: 'Ortodontia',
    sectionHof: 'HOF'
  },
  hof: {
    sideLeft: 'Esquerdo',
    sideRight: 'Direito',
    sideCenter: 'Central',
    sideLeftShort: 'E',
    sideRightShort: 'D',
    mark: 'Marcação',
    photoAlt: 'Foto de referência do paciente para o mapa HOF',
    anatomyAlt: 'Referência anatômica muscular, vista frontal',
    resultsAlt: 'Foto de resultado do tratamento',
    noneRegistered: 'Nenhuma marcação registrada',
    chooseBoth: 'Escolha a região e o procedimento',
    confirmRemove: 'Remover esta marcação do prontuário?',
    needMark: 'Adicione uma marcação para posicionar no mapa',
    imageType: 'Use uma imagem JPG ou PNG',
    imageSize: 'A imagem excede 15 MB',
    resultSaved: 'Foto de resultado salva no prontuário',
    photoSent: 'Foto enviada. Salve o prontuário para confirmar.',
    uploadError: 'Falha no envio da foto',
    mapSaved: 'Mapa HOF atualizado no prontuário',
    mapError: 'Erro ao salvar mapa HOF',
    discard: 'Descartar as alterações não salvas do mapa HOF?',
    uploading: 'Enviando...',
    replacePhoto: 'Trocar foto',
    selectImage: 'Selecionar imagem',
    noPermission: 'Seu perfil não permite enviar imagens.',
    fileHint: 'JPG ou PNG · até 15 MB',
    title: 'Harmonização orofacial',
    close: 'Fechar mapa HOF',
    history: 'Histórico',
    layers: 'Camadas do mapa HOF',
    zoom: 'Zoom',
    zoomOut: 'Diminuir zoom',
    zoomIn: 'Aumentar zoom',
    source: 'Origem da visualização',
    anatomy: 'Anatomia',
    patientPhoto: 'Foto do paciente',
    results: 'Resultados',
    layerFace: 'Rosto completo',
    layerFaceHint: 'Contorno e pontos de preenchimento / superfície',
    layerMuscles: 'Músculos',
    layerMusclesHint: 'Alvos de toxina e anatomia muscular',
    noAnnotations: 'Nenhuma anotação registrada',
    placedOne: '{count} anotação posicionada no mapa',
    placedMany: '{count} anotações posicionadas no mapa',
    unplaced: '{count} {word} · posição não confirmada no mapa',
    annotationOne: 'anotação',
    annotationMany: 'anotações',
    subtitleAnatomy: 'Mapa muscular · referência anatômica e registro de marcações',
    subtitleResults: 'Foto de resultado do tratamento',
    subtitleResultsEmpty: 'Foto de resultado - envie uma imagem diferente da foto do paciente',
    subtitlePhoto: 'Foto do paciente - posicione as marcações sobre a imagem',
    subtitlePhotoEmpty: 'Foto do paciente - preparar imagem para marcações',
    chartRecords: 'Registros HOF do prontuário',
    chartEmpty: 'Nenhum registro HOF no prontuário.',
    permanentRef: 'Referência anatômica permanente',
    illustration: 'Imagem anatômica ilustrativa · não é a foto do paciente.',
    preservedList: 'Anotações preservadas na lista, sem migração automática de pontos para os músculos.',
    states: 'Estados',
    region: 'Região',
    selectRegion: 'Selecionar região...',
    procedure: 'Procedimento / ação',
    selectProcedure: 'Selecionar procedimento...',
    notes: 'Observação',
    notesPlaceholder: 'Unidades, produto, plano, observação...',
    update: 'Atualizar',
    add: 'Adicionar',
    noneMark: 'Nenhuma marcação',
    noneMarkBody: 'Adicione uma região e o procedimento realizado ou planejado.',
    selectedInList: 'Selecionada na lista',
    inList: 'Marcação na lista',
    noPhotoPosition: 'Sem posição na foto',
    repositionMap: 'Reposicionar no mapa',
    placeMap: 'Posicionar no mapa',
    repositionPhoto: 'Reposicionar na foto',
    placePhoto: 'Posicionar na foto',
    placeOnMap: '{action} {label} no mapa',
    placeOnPhoto: '{action} {label} na foto',
    reposition: 'Reposicionar',
    place: 'Posicionar',
    editMark: 'Editar marcação',
    removeMark: 'Remover marcação',
    editNamed: 'Editar {label}',
    removeNamed: 'Remover {label}',
    marksTitle: 'Marcações',
    preservedRecordOne: '{count} registro preservado',
    preservedRecordMany: '{count} registros preservados',
    noPhotoPositions: 'sem posições na foto',
    positionedOne: '{count} posicionado na foto',
    positionedMany: '{count} posicionados na foto',
    stateDefault: 'Padrão',
    stateHighlight: 'Realçado',
    stateSelected: 'Selecionado',
    stateRisk: 'Zona de risco',
    existingOne: '{count} marcação existente preservada.',
    existingMany: '{count} marcações existentes preservadas.',
    legacyMarks: 'Marcações antigas, inclusive de camadas descontinuadas, continuam na lista e no prontuário.',
    anatomyDisclaimer: 'As regiões anatômicas são referências. Zonas de risco são registradas pelo profissional e nunca inferidas automaticamente.',
    frontView: 'VISTA FRONTAL',
    sideHint: 'D/E: lados do paciente, não do observador',
    resultsDrop: 'Envie a foto de resultado. Ela fica separada da foto do paciente.',
    photoDrop: 'Arraste a imagem do paciente aqui ou escolha um arquivo no computador.',
    photoTips: 'Prefira uma foto frontal. Rosto descoberto, cabeça alinhada, luz uniforme e fundo neutro. Mantenha toda a face visível.',
    photoAuth: 'Use somente uma imagem autorizada pelo paciente para o prontuário.',
    tapPhoto: 'Toque na foto para posicionar',
    tapMap: 'Toque no mapa para posicionar',
    cancel: 'Cancelar',
    placeMark: 'Posicionar marcação',
    unconfirmed: ' · posição não confirmada',
    detail: 'Detalhe da marcação selecionada',
    side: 'Lado do paciente',
    recordedNote: 'Anotação registrada',
    chartHistory: 'Histórico do prontuário',
    beforePlace: 'Antes de posicionar',
    beforePlaceBody: 'As anotações existentes permanecem no prontuário e precisam ser posicionadas manualmente sobre a foto do paciente.',
    unsaved: ' · alterações não salvas',
    closeAction: 'Fechar',
    saving: 'Salvando...',
    saveChart: 'Salvar prontuário',
    team: 'Equipe'
  },
  invite: {
    loading: 'Carregando convite...',
    invalid: 'Convite Inválido',
    notFound: 'Convite não encontrado',
    used: 'Este convite já foi usado ou expirou',
    expired: 'Este convite expirou',
    loadError: 'Erro ao carregar convite: {message}',
    backHome: 'Voltar ao Início',
    back: 'Voltar ao início',
    invited: 'Você foi convidado!',
    completeNamed: 'Complete seu cadastro para acessar o sistema da {clinic}',
    complete: 'Complete seu cadastro para acessar o sistema',
    clinicFallback: 'Clínica',
    validUntil: 'Convite válido até {date}',
    password: 'Senha',
    passwordRequired: 'Senha é obrigatória',
    passwordShort: 'Senha deve ter pelo menos 6 caracteres',
    passwordPlaceholder: 'Digite sua senha',
    confirm: 'Confirmar Senha',
    confirmRequired: 'Confirmação de senha é obrigatória',
    mismatch: 'As senhas não coincidem',
    confirmPlaceholder: 'Confirme sua senha',
    creating: 'Criando Conta...',
    create: 'Criar Conta',
    created: 'Conta criada com sucesso! Você pode fazer login agora.',
    createError: 'Erro ao criar conta: {message}',
    roleAdmin: 'Administrador',
    roleProfessional: 'Profissional',
    roleSecretary: 'Secretária'
  },
  confirmPage: {
    loading: 'Carregando agendamento...',
    errorTitle: 'Erro',
    notFound: 'Agendamento não encontrado ou link inválido',
    tokenMissing: 'Token não fornecido',
    backHome: 'Voltar ao Início',
    title: 'Confirmação de Agendamento',
    patient: 'Paciente',
    professional: 'Profissional',
    when: 'Data e Horário',
    procedure: 'Procedimento',
    passed: 'O horário deste agendamento já passou.',
    confirming: 'Confirmando...',
    confirm: 'Confirmar Agendamento',
    cancelling: 'Cancelando...',
    cancel: 'Cancelar Agendamento',
    confirmedOk: 'Seu agendamento foi confirmado com sucesso!',
    cancelledOk: 'Seu agendamento foi cancelado.',
    wait: 'Aguardamos você na data e horário marcados.',
    reschedule: 'Se precisar reagendar, entre em contato conosco.',
    alreadyConfirmed: 'Este agendamento já foi confirmado.',
    alreadyNoShow: 'Este agendamento foi registrado como falta.',
    alreadyCancelled: 'Este agendamento já foi cancelado.',
    statusConfirmed: 'Confirmado',
    statusCancelled: 'Cancelado',
    statusNoShow: 'Faltou',
    statusPending: 'Aguardando Confirmação',
    statusUnknown: 'Status Desconhecido',
    confirmOk: 'Agendamento confirmado com sucesso!',
    confirmError: 'Erro ao confirmar agendamento. Tente novamente.',
    cancelOk: 'Agendamento cancelado com sucesso!',
    cancelError: 'Erro ao cancelar agendamento. Tente novamente.'
  },
  clinic: {
    switched: 'Clínica alterada para {name}',
    switchError: 'Não foi possível trocar de clínica. Tente novamente.',
    created: 'Clínica criada com sucesso!',
    planLimit: 'O plano {plan} não inclui mais clínicas.',
    createError: 'Não foi possível criar a clínica. Tente novamente.',
    listLabel: 'Clínicas',
    plan: 'Plano',
    subscription: 'Assinatura',
    clinics: 'Clínicas',
    professionals: 'Profissionais',
    secretaries: 'Secretárias',
    storage: 'Armazenamento',
    create: 'Criar',
    newTitle: 'Nova clínica',
    name: 'Nome',
    namePlaceholder: 'Nome da clínica',
    description: 'Descrição',
    descriptionPlaceholder: 'Ex.: Unidade Principal',
    cancel: 'Cancelar',
    creating: 'Criando…'
  },
  billingReturn: {
    paidTitle: 'Pagamento confirmado',
    paidBody: 'A assinatura da clínica aparece em Configurações em alguns segundos.',
    cancelTitle: 'Checkout cancelado',
    cancelBody: 'Nenhum valor foi cobrado. Você pode escolher o plano de novo quando quiser.',
    viewSubscription: 'Ver assinatura',
    backPlans: 'Voltar aos planos',
    dashboard: 'Ir ao dashboard'
  },
  logout: {
    closing: 'Encerrando sessão...'
  },
  quick: {
    copied: 'Mensagem de confirmação copiada',
    copyError: 'Não foi possível copiar o link',
    whatsappOk: 'WhatsApp aberto para reenvio da confirmação',
    whatsappError: 'Não foi possível preparar o reenvio',
    copy: 'Copiar',
    copyMessage: 'Copiar mensagem',
    whatsapp: 'WhatsApp',
    sendWhatsapp: 'Enviar no WhatsApp',
    edit: 'Editar',
    editAppointment: 'Editar agendamento'
  },
  pix: {
    copied: 'Código Pix copiado',
    copyError: 'Não foi possível copiar o código',
    title: 'Pague com Pix',
    body: '{plan} · {amount}. O QR expira em até 48h.',
    alt: 'QR Code Pix',
    copy: 'Copiar código Pix',
    copiedAction: 'Copiado',
    open: 'Abrir página de pagamento OpenPix',
    sandbox: 'Sandbox: aprove a cobrança em',
    sandboxOr: 'ou com',
    autoRelease: 'A assinatura libera automaticamente quando o Pix for confirmado.'
  },
  setup: {
    creating: 'Criando...',
    createAdmin: 'Criar Administrador e Continuar',
    step1: 'Passo 1: Usuário Administrador',
    step1Body: 'Crie o primeiro usuário administrador do sistema',
    name: 'Nome Completo',
    namePlaceholder: 'Nome do administrador',
    email: 'Email',
    password: 'Senha',
    confirmPassword: 'Confirmar Senha',
    required: 'Por favor, preencha todos os campos obrigatórios',
    passwordShort: 'A senha deve ter pelo menos 6 caracteres',
    mismatch: 'As senhas não coincidem',
    createdToast: 'Usuário administrador da clínica criado com sucesso!',
    createError: 'Erro ao criar usuário: {message}',
    redirecting: 'Redirecionando para configuração da clínica...',
    step2: 'Passo 2: Finalizar Configuração',
    step2Body: 'Usuário administrador criado! Agora você será redirecionado para configurar sua clínica.',
    created: 'Usuário administrador criado com sucesso!',
    redirect: 'Agora você será redirecionado para configurar sua clínica no onboarding.',
    back: 'Voltar',
    goConfig: 'Ir para Configuração',
    fullAccess: 'Este usuário terá acesso total ao sistema',
    afterSetup: 'Após a configuração, você poderá fazer login e começar a usar o sistema'
  }
};

const moreEn = {
  ...shell(1),
  anamnesis: {
    healthConditions: 'Health conditions',
    healthConditionsHint: 'E.g. hypertension, diabetes, pregnancy...',
    allergies: 'Allergies',
    allergiesHint: 'Medication, latex, anesthetics...',
    medications: 'Current medication',
    medicationsHint: 'Name, dose and frequency',
    chiefComplaint: 'Chief complaint',
    chiefComplaintHint: 'Reason for the visit in the patient’s words'
  },
  overview: {
    incompleteTitle: 'Incomplete registration',
    incompleteBody: 'fill in the details before recording new visits. Missing information does not mean the clinical condition is absent.',
    identity: 'Identification and contact',
    completeRegistration: 'Complete registration',
    editRegistration: 'Edit registration',
    name: 'Name',
    birthAge: 'Date of birth / age',
    document: 'ID document',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    card: 'Insurance card',
    pendingLine: 'Missing from registration: {items}.',
    pendingBirth: 'date of birth',
    pendingCpf: 'ID number',
    pendingPhone: 'phone',
    pendingEmail: 'email',
    pendingAddress: 'address',
    invalidDate: 'Invalid date',
    age: '{age} years',
    anamnesis: 'Medical history',
    registerAnamnesis: 'Record history',
    editAnamnesis: 'Edit history',
    cancel: 'Cancel',
    saving: 'Saving...',
    saveAnamnesis: 'Save history',
    anamnesisEmpty: 'No medical history recorded. Missing information does not mean there is no health condition, allergy or medication.',
    notesTitle: 'Patient notes',
    addNote: 'Add note',
    newNote: 'New note',
    notePlaceholder: 'Progress, conduct, instructions and visit notes...',
    noNotes: 'No notes available.',
    noNotesBody: 'Record instructions and information relevant to follow-up.',
    registrationNote: 'Registration note',
    team: 'Team',
    history: 'Visits and history',
    registerVisit: 'Record visit',
    loadingHistory: 'Loading history...',
    noHistory: 'Visit history not recorded.',
    noHistoryHof: 'The HOF records beside this do not confirm a completed visit. Record the visit to link the history.',
    noHistoryBody: 'Record a visit to start this patient’s history.',
    visitFallback: 'Visit',
    dateUnavailable: 'Date unavailable',
    professionalUnknown: 'Professional not informed',
    showing: 'Showing {shown} of {total} visits.',
    hofTitle: 'HOF records',
    viewHof: 'View HOF',
    noHof: 'No HOF records on the chart.',
    hofCount: '{count} {word} on the chart',
    recordOne: 'record',
    recordMany: 'records',
    hofMore: 'and {count} more on the HOF map.',
    hofNoPhoto: 'Records kept without a patient photo: positions on the image are not set yet.',
    sections: 'Chart sections',
    odontogram: 'Odontogram',
    media: 'Media',
    loadingMedia: 'Loading media...',
    noMedia: 'No media uploaded',
    fileOne: 'file',
    fileMany: 'files',
    orthoMedia: 'orthodontic',
    orthoMediaMany: 'orthodontic',
    toothOne: 'tooth',
    toothMany: 'teeth',
    odoSummary: '{teeth} {toothWord} with findings · {records} {recordWord}',
    odoEmpty: 'Dental assessment not recorded',
    hofIllustration: 'The HOF face illustration is an anatomical reference and does not depict the patient. Use an authorized photo on the HOF tab to place marks.',
    footer: 'Keep the chart current with information confirmed by the patient and recorded by the professional.',
    notInformed: 'Not informed',
    historyError: 'Could not load visit history',
    anamnesisSaved: 'Medical history saved',
    anamnesisError: 'Could not save medical history',
    noteRequired: 'Write the note',
    noteSaved: 'Note added',
    noteError: 'Could not save the note'
  },
  patientForm: {
    editTitle: 'Edit patient',
    newTitle: 'New patient',
    editSubtitle: 'Update the patient information',
    newSubtitle: 'Fill in the new patient information',
    fullName: 'Full name *',
    nameRequired: 'Name is required',
    namePlaceholder: 'Patient full name',
    email: 'Email',
    emailPlaceholder: 'email@example.com',
    phone: 'Phone *',
    phoneRequired: 'Phone is required',
    phoneInvalid: 'Enter a valid phone: (99) 9999-9999 or (99) 99999-9999',
    cpf: 'ID number',
    cpfInvalid: 'Invalid ID number',
    card: 'Insurance card number',
    cardPlaceholder: 'Plan or insurance number',
    birth: 'Date of birth',
    address: 'Address',
    addressPlaceholder: 'Full address',
    notes: 'Notes',
    notesPlaceholder: 'Notes about the patient...',
    active: 'Active patient',
    cancel: 'Cancel',
    saving: 'Saving...',
    update: 'Update',
    create: 'Create',
    updated: 'Patient updated.',
    created: 'Patient created.',
    saveError: 'Could not save the patient',
    missingClinic: 'Clinic id was not found'
  },
  autocomplete: {
    placeholder: 'Type at least 2 letters to search',
    clear: 'Clear',
    noContact: 'No contact',
    minChars: 'Type at least {count} characters to search',
    none: 'No patient found for “{query}”'
  },
  odo: {
    title: 'Odontogram',
    subtitle: '{dentition} dentition · select a tooth to start a record.',
    history: 'History',
    historyTitle: 'Odontogram history',
    historyEmpty: 'No records added to the odontogram.',
    dentition: 'Dentition',
    permanent: 'Permanent',
    deciduous: 'Primary',
    notation: 'FDI notation · {count} positions',
    generalNotes: 'General odontogram notes',
    generalPlaceholder: 'Record notes after the dental assessment...',
    selection: 'Selection to record',
    selectionTooth: 'Selection to record · Tooth {tooth}',
    selectionRegion: 'Selection to record · {regions}',
    regionOnly: 'Scaling region, no specific tooth.',
    noneSelected: 'No tooth selected.',
    toothOrRegion: 'Tooth or region',
    selectTooth: 'Select tooth...',
    toothOption: 'Tooth {tooth}',
    toothSelected: 'Tooth {tooth} · visual selection',
    region: 'Region',
    regionHint: 'Mark one or more scaling regions.',
    surface: 'Surface',
    surfaceHint: 'Select a tooth to see the surfaces.',
    condition: 'Condition / clinical finding',
    recordNotes: 'Record note',
    recordPlaceholder: 'Material, conduct, finding description...',
    addHintTooth: 'The record goes into the tooth history and updates the map after the professional confirms it.',
    addHintRegion: 'The record goes into the region history. The tooth map stays without this mark.',
    addHintEmpty: 'Select the tooth or one or more regions and the condition, such as scaling.',
    add: 'Add record',
    toothHistory: 'Tooth {tooth} history',
    regionHistory: 'Region history',
    toothHistoryEmpty: 'Tooth history',
    clearMap: 'Remove finding from the map',
    pickTooth: 'Select a tooth',
    pickToothBody: 'Records for each position appear here. Scaling regions stay in this history.',
    noRecord: 'Record unavailable',
    noRecordBody: 'No dental information was provided for this position.',
    dirty: 'Changes are not saved on the chart yet.',
    saved: 'Odontogram saved on the chart.',
    clearSelection: 'Clear selection',
    saving: 'Saving...',
    save: 'Save odontogram',
    footnote: 'The diagram is a schematic. Neutral teeth do not mean healthy teeth.',
    added: 'Record added on {target}. Save the odontogram to confirm.',
    toothTarget: 'tooth {tooth}',
    saveOk: 'Odontogram updated on the chart',
    saveError: 'Could not save the odontogram',
    team: 'Team',
    states: 'States',
    unevaluated: 'Not assessed',
    selectedToRecord: 'Selected to record',
    withRecord: 'With a record',
    maxilla: 'MAXILLA',
    mandible: 'MANDIBLE',
    patientRight: 'R - patient’s right',
    patientLeft: 'L - patient’s left',
    archMaxilla: 'Maxilla',
    archMandible: 'Mandible',
    sideRight: 'patient’s right side',
    sideLeft: 'patient’s left side',
    toothStateSelected: 'selected',
    toothStateRecorded: 'with a record',
    toothStateNone: 'not assessed',
    toothAria: 'Tooth {tooth}, {state}',
    legacyO: 'Occlusal / Incisal',
    legacyL: 'Lingual / Palatal'
  },
  ortho: {
    title: 'Orthodontics',
    subtitle: 'Follow-up and appliance maintenance records',
    evolution: 'Orthodontic progress',
    evolutionBody: 'Visit history, wires used and appliance activations',
    empty: 'No maintenance recorded.',
    emptyBody: 'Use the form beside this to start this patient’s orthodontic history.',
    recordOne: 'record',
    recordMany: 'records',
    newest: 'Newest first',
    noDate: 'No date',
    team: 'Team',
    applianceUnknown: 'Appliance not informed',
    upper: 'Upper',
    lower: 'Lower',
    procedure: 'Procedure performed',
    hygiene: 'Hygiene {label}',
    hygieneUnknown: 'Hygiene not assessed',
    register: 'Record maintenance',
    registerBody: 'Enter today’s activation details',
    appliance: 'Appliance type',
    selectAppliance: 'Select appliance…',
    upperArch: 'Upper arch',
    lowerArch: 'Lower arch',
    select: 'Select…',
    conduct: 'Conduct / activation',
    conductPlaceholder: 'Describe ties, springs, elastics and other steps…',
    oralHygiene: 'Patient oral hygiene',
    hygieneGroup: 'Patient oral hygiene',
    hygieneLine: 'Hygiene {label}.',
    hygieneNone: 'Not assessed · no option selected',
    note: 'Enter only information verified during the visit. The fields have no clinical data.',
    saving: 'Saving...',
    confirm: 'Confirm progress',
    photos: 'Orthodontic control photos',
    photosHint: 'On the Media tab · Orthodontic photos filter',
    viewPhotos: 'View photos and compare before/after',
    footer: 'Keep the chart current with information confirmed by the patient and recorded by the professional.',
    saved: 'Orthodontic progress recorded',
    saveError: 'Could not record progress',
    hygieneExcelente: 'Excellent',
    hygieneRegular: 'Fair',
    hygieneRuim: 'Poor'
  },
  media: {
    title: 'Media',
    subtitle: 'Chart photos, exams and documents, organized by section.',
    uploading: 'Uploading...',
    upload: 'Upload files',
    locked: 'Media attachments are not available on the current plan. Existing files stay visible.',
    filters: 'Media filters',
    all: 'All',
    images: 'Images',
    exams: 'Exams',
    documents: 'Documents',
    orthoPhotos: 'Orthodontic photos',
    dropOrtho: 'Drop orthodontic photos here',
    dropFiles: 'Drop files here',
    dropOrthoHint: 'JPG or PNG · organized in the Orthodontics section',
    dropHint: 'Images, PDF or MP4 · up to 15 MB · section {section}',
    select: 'Select',
    loading: 'Loading media...',
    emptySuffix: ' - no clinical file provided',
    emptyOrtho: 'No orthodontic photos',
    emptyFilter: 'No media in this filter',
    emptyOrthoBody: 'Control photos added on the Media tab and organized under Orthodontics appear here for comparison.',
    emptyFilterBody: 'Upload photos, exams or documents to organize the chart.',
    compare: 'Compare before / after',
    base: 'Base - before',
    overlay: 'Overlay - after',
    selectPhoto: 'Select photo...',
    opacity: 'Overlay opacity',
    before: 'Before',
    after: 'After',
    needImage: 'Upload at least one image to preview.',
    pickPreview: 'Select a photo to preview. The second one is overlaid.',
    details: 'Image details',
    noneSelected: 'No photo selected',
    section: 'Organization section',
    caption: 'Description / note',
    captionPlaceholder: 'Context, record date, patient authorization...',
    saving: 'Saving...',
    saveOrg: 'Save organization',
    noPhotoYet: 'No photo has been provided for this patient yet.',
    pickFile: 'Select a file in the gallery to edit the section and description.',
    planError: 'Media attachments are not available on this plan',
    uploadedOne: 'File uploaded',
    uploadedMany: '{count} files uploaded',
    removed: 'File removed',
    removeNamed: 'Remove "{name}"?',
    removeHofPhoto: 'Remove "{name}"? This image is the patient photo on the HOF map.',
    removeHofResult: 'Remove "{name}"? This image is the result photo on the HOF map.',
    removeError: 'Could not remove',
    orgSaved: 'Organization saved',
    orgError: 'Could not save organization',
    orthoCountOne: 'orthodontic photo',
    orthoCountMany: 'orthodontic photos',
    team: 'Team',
    preserve: 'Keep the authorization and context of each chart file.',
    open: 'Open',
    remove: 'Remove',
    close: 'Close',
    storage: 'Storage: {used} / {quota} ({plan}/clinic)',
    orthoType: '{name}: use JPG or PNG for orthodontic photos',
    uploadFail: 'upload failed',
    selectNamed: 'Select {name}',
    sectionClinical: 'Clinical',
    sectionExam: 'Exams',
    sectionDocument: 'Documents',
    sectionOrtho: 'Orthodontics',
    sectionHof: 'HOF'
  },
  hof: {
    sideLeft: 'Left',
    sideRight: 'Right',
    sideCenter: 'Center',
    sideLeftShort: 'L',
    sideRightShort: 'R',
    mark: 'Mark',
    photoAlt: 'Patient reference photo for the HOF map',
    anatomyAlt: 'Muscular anatomical reference, frontal view',
    resultsAlt: 'Treatment result photo',
    noneRegistered: 'No marks recorded',
    chooseBoth: 'Choose the region and the procedure',
    confirmRemove: 'Remove this mark from the chart?',
    needMark: 'Add a mark before placing it on the map',
    imageType: 'Use a JPG or PNG image',
    imageSize: 'The image exceeds 15 MB',
    resultSaved: 'Result photo saved on the chart',
    photoSent: 'Photo uploaded. Save the chart to confirm.',
    uploadError: 'Photo upload failed',
    mapSaved: 'HOF map updated on the chart',
    mapError: 'Could not save the HOF map',
    discard: 'Discard unsaved HOF map changes?',
    uploading: 'Uploading...',
    replacePhoto: 'Replace photo',
    selectImage: 'Select image',
    noPermission: 'Your profile cannot upload images.',
    fileHint: 'JPG or PNG · up to 15 MB',
    title: 'Orofacial harmonization',
    close: 'Close HOF map',
    history: 'History',
    layers: 'HOF map layers',
    zoom: 'Zoom',
    zoomOut: 'Zoom out',
    zoomIn: 'Zoom in',
    source: 'View source',
    anatomy: 'Anatomy',
    patientPhoto: 'Patient photo',
    results: 'Results',
    layerFace: 'Full face',
    layerFaceHint: 'Contour and filler / surface points',
    layerMuscles: 'Muscles',
    layerMusclesHint: 'Toxin targets and muscle anatomy',
    noAnnotations: 'No annotations recorded',
    placedOne: '{count} annotation placed on the map',
    placedMany: '{count} annotations placed on the map',
    unplaced: '{count} {word} · position not confirmed on the map',
    annotationOne: 'annotation',
    annotationMany: 'annotations',
    subtitleAnatomy: 'Muscle map · anatomical reference and mark records',
    subtitleResults: 'Treatment result photo',
    subtitleResultsEmpty: 'Result photo - upload an image other than the patient photo',
    subtitlePhoto: 'Patient photo - place the marks on the image',
    subtitlePhotoEmpty: 'Patient photo - prepare an image for marks',
    chartRecords: 'HOF records on the chart',
    chartEmpty: 'No HOF records on the chart.',
    permanentRef: 'Permanent anatomical reference',
    illustration: 'Illustrative anatomical image · not the patient’s photo.',
    preservedList: 'Notes stay in the list, with no automatic migration of points onto the muscles.',
    states: 'States',
    region: 'Region',
    selectRegion: 'Select region...',
    procedure: 'Procedure / action',
    selectProcedure: 'Select procedure...',
    notes: 'Note',
    notesPlaceholder: 'Units, product, plan, note...',
    update: 'Update',
    add: 'Add',
    noneMark: 'No marks',
    noneMarkBody: 'Add a region and the procedure performed or planned.',
    selectedInList: 'Selected in the list',
    inList: 'Mark in the list',
    noPhotoPosition: 'No position on the photo',
    repositionMap: 'Reposition on the map',
    placeMap: 'Place on the map',
    repositionPhoto: 'Reposition on the photo',
    placePhoto: 'Place on the photo',
    placeOnMap: '{action} {label} on the map',
    placeOnPhoto: '{action} {label} on the photo',
    reposition: 'Reposition',
    place: 'Place',
    editMark: 'Edit mark',
    removeMark: 'Remove mark',
    editNamed: 'Edit {label}',
    removeNamed: 'Remove {label}',
    marksTitle: 'Marks',
    preservedRecordOne: '{count} preserved record',
    preservedRecordMany: '{count} preserved records',
    noPhotoPositions: 'no positions on the photo',
    positionedOne: '{count} placed on the photo',
    positionedMany: '{count} placed on the photo',
    stateDefault: 'Default',
    stateHighlight: 'Highlighted',
    stateSelected: 'Selected',
    stateRisk: 'Risk zone',
    existingOne: '{count} existing mark preserved.',
    existingMany: '{count} existing marks preserved.',
    legacyMarks: 'Older marks, including discontinued layers, stay in the list and on the chart.',
    anatomyDisclaimer: 'Anatomical regions are references. Risk zones are recorded by the professional and are never inferred automatically.',
    frontView: 'FRONT VIEW',
    sideHint: 'R/L: the patient’s sides, not the observer’s',
    resultsDrop: 'Upload the result photo. It stays separate from the patient photo.',
    photoDrop: 'Drop the patient image here or choose a file on the computer.',
    photoTips: 'Prefer a frontal photo. Uncovered face, aligned head, even light and a neutral background. Keep the whole face visible.',
    photoAuth: 'Use only an image authorized by the patient for the chart.',
    tapPhoto: 'Tap the photo to place',
    tapMap: 'Tap the map to place',
    cancel: 'Cancel',
    placeMark: 'Place mark',
    unconfirmed: ' · position not confirmed',
    detail: 'Selected mark details',
    side: 'Patient side',
    recordedNote: 'Recorded note',
    chartHistory: 'Chart history',
    beforePlace: 'Before placing',
    beforePlaceBody: 'Existing notes stay on the chart and must be placed manually on the patient photo.',
    unsaved: ' · unsaved changes',
    closeAction: 'Close',
    saving: 'Saving...',
    saveChart: 'Save chart',
    team: 'Team'
  },
  invite: {
    loading: 'Loading invite...',
    invalid: 'Invalid invite',
    notFound: 'Invite not found',
    used: 'This invite was already used or has expired',
    expired: 'This invite has expired',
    loadError: 'Could not load the invite: {message}',
    backHome: 'Back to home',
    back: 'Back to home',
    invited: 'You were invited!',
    completeNamed: 'Complete your registration to access {clinic}',
    complete: 'Complete your registration to access the system',
    clinicFallback: 'Clinic',
    validUntil: 'Invite valid until {date}',
    password: 'Password',
    passwordRequired: 'Password is required',
    passwordShort: 'Password must be at least 6 characters',
    passwordPlaceholder: 'Enter your password',
    confirm: 'Confirm password',
    confirmRequired: 'Password confirmation is required',
    mismatch: 'Passwords do not match',
    confirmPlaceholder: 'Confirm your password',
    creating: 'Creating account...',
    create: 'Create account',
    created: 'Account created. You can sign in now.',
    createError: 'Could not create the account: {message}',
    roleAdmin: 'Administrator',
    roleProfessional: 'Professional',
    roleSecretary: 'Secretary'
  },
  confirmPage: {
    loading: 'Loading appointment...',
    errorTitle: 'Error',
    notFound: 'Appointment not found or invalid link',
    tokenMissing: 'Token not provided',
    backHome: 'Back to home',
    title: 'Appointment confirmation',
    patient: 'Patient',
    professional: 'Professional',
    when: 'Date and time',
    procedure: 'Procedure',
    passed: 'This appointment time has already passed.',
    confirming: 'Confirming...',
    confirm: 'Confirm appointment',
    cancelling: 'Cancelling...',
    cancel: 'Cancel appointment',
    confirmedOk: 'Your appointment was confirmed.',
    cancelledOk: 'Your appointment was cancelled.',
    wait: 'We will see you at the scheduled date and time.',
    reschedule: 'If you need to reschedule, contact us.',
    alreadyConfirmed: 'This appointment is already confirmed.',
    alreadyNoShow: 'This appointment was recorded as a no-show.',
    alreadyCancelled: 'This appointment is already cancelled.',
    statusConfirmed: 'Confirmed',
    statusCancelled: 'Cancelled',
    statusNoShow: 'No-show',
    statusPending: 'Awaiting confirmation',
    statusUnknown: 'Unknown status',
    confirmOk: 'Appointment confirmed.',
    confirmError: 'Could not confirm the appointment. Try again.',
    cancelOk: 'Appointment cancelled.',
    cancelError: 'Could not cancel the appointment. Try again.'
  },
  clinic: {
    switched: 'Clinic changed to {name}',
    switchError: 'Could not switch clinics. Try again.',
    created: 'Clinic created.',
    planLimit: 'The {plan} plan does not include more clinics.',
    createError: 'Could not create the clinic. Try again.',
    listLabel: 'Clinics',
    plan: 'Plan',
    subscription: 'Subscription',
    clinics: 'Clinics',
    professionals: 'Professionals',
    secretaries: 'Secretaries',
    storage: 'Storage',
    create: 'Create',
    newTitle: 'New clinic',
    name: 'Name',
    namePlaceholder: 'Clinic name',
    description: 'Description',
    descriptionPlaceholder: 'E.g. Main office',
    cancel: 'Cancel',
    creating: 'Creating…'
  },
  billingReturn: {
    paidTitle: 'Payment confirmed',
    paidBody: 'The clinic subscription appears in Settings within a few seconds.',
    cancelTitle: 'Checkout cancelled',
    cancelBody: 'Nothing was charged. You can choose a plan again whenever you want.',
    viewSubscription: 'View subscription',
    backPlans: 'Back to plans',
    dashboard: 'Go to dashboard'
  },
  logout: {
    closing: 'Signing out...'
  },
  quick: {
    copied: 'Confirmation message copied',
    copyError: 'Could not copy the link',
    whatsappOk: 'WhatsApp opened to resend the confirmation',
    whatsappError: 'Could not prepare the resend',
    copy: 'Copy',
    copyMessage: 'Copy message',
    whatsapp: 'WhatsApp',
    sendWhatsapp: 'Send on WhatsApp',
    edit: 'Edit',
    editAppointment: 'Edit appointment'
  },
  pix: {
    copied: 'Pix code copied',
    copyError: 'Could not copy the code',
    title: 'Pay with Pix',
    body: '{plan} · {amount}. The QR expires within 48h.',
    alt: 'Pix QR code',
    copy: 'Copy Pix code',
    copiedAction: 'Copied',
    open: 'Open OpenPix payment page',
    sandbox: 'Sandbox: approve the charge at',
    sandboxOr: 'or with',
    autoRelease: 'The subscription unlocks automatically when the Pix payment is confirmed.'
  },
  setup: {
    creating: 'Creating...',
    createAdmin: 'Create administrator and continue',
    step1: 'Step 1: Administrator',
    step1Body: 'Create the first administrator for the system',
    name: 'Full name',
    namePlaceholder: 'Administrator name',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    required: 'Please fill in all required fields',
    passwordShort: 'The password must be at least 6 characters',
    mismatch: 'The passwords do not match',
    createdToast: 'Clinic administrator created.',
    createError: 'Could not create the user: {message}',
    redirecting: 'Redirecting to clinic setup...',
    step2: 'Step 2: Finish setup',
    step2Body: 'Administrator created. You will be redirected to set up your clinic.',
    created: 'Administrator created.',
    redirect: 'You will now be redirected to set up your clinic in onboarding.',
    back: 'Back',
    goConfig: 'Go to setup',
    fullAccess: 'This user will have full access to the system',
    afterSetup: 'After setup, you can sign in and start using the system'
  }
};

const moreEs = {
  ...shell(2),
  anamnesis: {
    healthConditions: 'Condiciones de salud',
    healthConditionsHint: 'Ej.: hipertensión, diabetes, embarazo...',
    allergies: 'Alergias',
    allergiesHint: 'Medicamentos, látex, anestésicos...',
    medications: 'Medicamentos en uso',
    medicationsHint: 'Nombre, dosis y frecuencia',
    chiefComplaint: 'Motivo de consulta',
    chiefComplaintHint: 'Motivo de la consulta en palabras del paciente'
  },
  overview: {
    incompleteTitle: 'Registro incompleto',
    incompleteBody: 'complete los datos antes de registrar nuevas consultas. La información no registrada no significa ausencia de condición clínica.',
    identity: 'Identificación y contacto',
    completeRegistration: 'Completar registro',
    editRegistration: 'Editar registro',
    name: 'Nombre',
    birthAge: 'Fecha de nacimiento / edad',
    document: 'Documento',
    phone: 'Teléfono',
    email: 'Correo',
    address: 'Dirección',
    card: 'Carnet',
    pendingLine: 'Pendiente en el registro: {items}.',
    pendingBirth: 'fecha de nacimiento',
    pendingCpf: 'documento',
    pendingPhone: 'teléfono',
    pendingEmail: 'correo',
    pendingAddress: 'dirección',
    invalidDate: 'Fecha inválida',
    age: '{age} años',
    anamnesis: 'Anamnesis',
    registerAnamnesis: 'Registrar anamnesis',
    editAnamnesis: 'Editar anamnesis',
    cancel: 'Cancelar',
    saving: 'Guardando...',
    saveAnamnesis: 'Guardar anamnesis',
    anamnesisEmpty: 'No hay anamnesis registrada. La información no registrada no significa ausencia de condición de salud, alergia o medicamento.',
    notesTitle: 'Observaciones del paciente',
    addNote: 'Agregar observación',
    newNote: 'Nueva observación',
    notePlaceholder: 'Evolución, conducta, orientaciones y observaciones de la consulta...',
    noNotes: 'No hay observaciones.',
    noNotesBody: 'Registre orientaciones e información relevante para el seguimiento.',
    registrationNote: 'Observación del registro',
    team: 'Equipo',
    history: 'Consultas e historial',
    registerVisit: 'Registrar consulta',
    loadingHistory: 'Cargando historial...',
    noHistory: 'Historial de consultas no informado.',
    noHistoryHof: 'Los registros HOF al lado no confirman una consulta realizada. Registre la atención para vincular el historial.',
    noHistoryBody: 'Registre la atención para iniciar el historial de este paciente.',
    visitFallback: 'Consulta',
    dateUnavailable: 'Fecha no disponible',
    professionalUnknown: 'Profesional no informado',
    showing: 'Mostrando {shown} de {total} consultas.',
    hofTitle: 'Registros HOF',
    viewHof: 'Ver HOF',
    noHof: 'Ningún registro HOF en la ficha.',
    hofCount: '{count} {word} en la ficha',
    recordOne: 'registro',
    recordMany: 'registros',
    hofMore: 'y {count} más en el mapa HOF.',
    hofNoPhoto: 'Registros conservados sin foto del paciente: las posiciones en la imagen aún no se definieron.',
    sections: 'Secciones de la ficha',
    odontogram: 'Odontograma',
    media: 'Medios',
    loadingMedia: 'Cargando medios...',
    noMedia: 'Ningún archivo enviado',
    fileOne: 'archivo',
    fileMany: 'archivos',
    orthoMedia: 'ortodóncica',
    orthoMediaMany: 'ortodóncicas',
    toothOne: 'diente',
    toothMany: 'dientes',
    odoSummary: '{teeth} {toothWord} con hallazgo · {records} {recordWord}',
    odoEmpty: 'Evaluación odontológica no registrada',
    hofIllustration: 'La ilustración facial del mapa HOF es una referencia anatómica y no representa al paciente. Use una foto autorizada en la pestaña HOF para ubicar las marcas.',
    footer: 'Mantenga la ficha actualizada con información confirmada por el paciente y registros del profesional.',
    notInformed: 'No informado',
    historyError: 'No se pudo cargar el historial de consultas',
    anamnesisSaved: 'Anamnesis registrada',
    anamnesisError: 'No se pudo guardar la anamnesis',
    noteRequired: 'Escriba la observación',
    noteSaved: 'Observación agregada',
    noteError: 'No se pudo guardar la observación'
  },
  patientForm: {
    editTitle: 'Editar paciente',
    newTitle: 'Nuevo paciente',
    editSubtitle: 'Actualice la información del paciente',
    newSubtitle: 'Complete la información del nuevo paciente',
    fullName: 'Nombre completo *',
    nameRequired: 'El nombre es obligatorio',
    namePlaceholder: 'Nombre completo del paciente',
    email: 'Correo',
    emailPlaceholder: 'correo@ejemplo.com',
    phone: 'Teléfono *',
    phoneRequired: 'El teléfono es obligatorio',
    phoneInvalid: 'Indique un teléfono válido: (99) 9999-9999 o (99) 99999-9999',
    cpf: 'Documento',
    cpfInvalid: 'Documento inválido',
    card: 'Número de carnet',
    cardPlaceholder: 'Número del convenio o plan',
    birth: 'Fecha de nacimiento',
    address: 'Dirección',
    addressPlaceholder: 'Dirección completa',
    notes: 'Observaciones',
    notesPlaceholder: 'Observaciones sobre el paciente...',
    active: 'Paciente activo',
    cancel: 'Cancelar',
    saving: 'Guardando...',
    update: 'Actualizar',
    create: 'Crear',
    updated: 'Paciente actualizado.',
    created: 'Paciente creado.',
    saveError: 'No se pudo guardar el paciente',
    missingClinic: 'No se encontró el id de la clínica'
  },
  autocomplete: {
    placeholder: 'Escriba al menos 2 letras para buscar',
    clear: 'Limpiar',
    noContact: 'Sin contacto',
    minChars: 'Escriba al menos {count} caracteres para buscar',
    none: 'Ningún paciente encontrado para “{query}”'
  },
  odo: {
    title: 'Odontograma',
    subtitle: 'Dentición {dentition} · seleccione un diente para iniciar un registro.',
    history: 'Historial',
    historyTitle: 'Historial del odontograma',
    historyEmpty: 'Ningún registro agregado al odontograma.',
    dentition: 'Dentición',
    permanent: 'Permanente',
    deciduous: 'Temporal',
    notation: 'Notación FDI · {count} posiciones',
    generalNotes: 'Observaciones generales del odontograma',
    generalPlaceholder: 'Registre observaciones después de la evaluación odontológica...',
    selection: 'Selección para registrar',
    selectionTooth: 'Selección para registrar · Diente {tooth}',
    selectionRegion: 'Selección para registrar · {regions}',
    regionOnly: 'Región del raspado, sin diente específico.',
    noneSelected: 'Ningún diente seleccionado.',
    toothOrRegion: 'Diente o región',
    selectTooth: 'Seleccionar diente...',
    toothOption: 'Diente {tooth}',
    toothSelected: 'Diente {tooth} · selección visual',
    region: 'Región',
    regionHint: 'Marque una o más regiones del raspado.',
    surface: 'Cara / superficie',
    surfaceHint: 'Seleccione un diente para ver las caras.',
    condition: 'Condición / hallazgo clínico',
    recordNotes: 'Observación del registro',
    recordPlaceholder: 'Material, conducta, descripción del hallazgo...',
    addHintTooth: 'El registro entra en el historial del diente y actualiza el mapa después de la confirmación del profesional.',
    addHintRegion: 'El registro entra en el historial de la región. El mapa de dientes queda sin esta marca.',
    addHintEmpty: 'Seleccione el diente o una o más regiones y la condición, como el raspado.',
    add: 'Agregar registro',
    toothHistory: 'Historial del diente {tooth}',
    regionHistory: 'Historial de las regiones',
    toothHistoryEmpty: 'Historial del diente',
    clearMap: 'Quitar hallazgo del mapa',
    pickTooth: 'Seleccione un diente',
    pickToothBody: 'Los registros de cada posición aparecen aquí. Las regiones del raspado quedan en este historial.',
    noRecord: 'Registro no disponible',
    noRecordBody: 'No hay información odontológica para esta posición.',
    dirty: 'Cambios aún no guardados en la ficha.',
    saved: 'Odontograma guardado en la ficha.',
    clearSelection: 'Limpiar selección',
    saving: 'Guardando...',
    save: 'Guardar odontograma',
    footnote: 'El diagrama es esquemático. Los dientes neutros no representan dientes sanos.',
    added: 'Registro agregado en {target}. Guarde el odontograma para confirmar.',
    toothTarget: 'diente {tooth}',
    saveOk: 'Odontograma actualizado en la ficha',
    saveError: 'No se pudo guardar el odontograma',
    team: 'Equipo',
    states: 'Estados',
    unevaluated: 'No evaluado',
    selectedToRecord: 'Seleccionado para registrar',
    withRecord: 'Con registro',
    maxilla: 'MAXILAR',
    mandible: 'MANDÍBULA',
    patientRight: 'D - derecho del paciente',
    patientLeft: 'I - izquierdo del paciente',
    archMaxilla: 'Maxilar',
    archMandible: 'Mandíbula',
    sideRight: 'lado derecho del paciente',
    sideLeft: 'lado izquierdo del paciente',
    toothStateSelected: 'seleccionado',
    toothStateRecorded: 'con registro',
    toothStateNone: 'no evaluado',
    toothAria: 'Diente {tooth}, {state}',
    legacyO: 'Oclusal / Incisal',
    legacyL: 'Lingual / Palatina'
  },
  ortho: {
    title: 'Ortodoncia',
    subtitle: 'Seguimiento y registro de mantenimientos del aparato',
    evolution: 'Evolución ortodóncica',
    evolutionBody: 'Historial de consultas, arcos utilizados y activaciones del aparato',
    empty: 'Ningún mantenimiento registrado.',
    emptyBody: 'Use el formulario al lado para iniciar el historial ortodóncico de este paciente.',
    recordOne: 'registro',
    recordMany: 'registros',
    newest: 'Más reciente primero',
    noDate: 'Sin fecha',
    team: 'Equipo',
    applianceUnknown: 'Aparato no informado',
    upper: 'Superiores',
    lower: 'Inferiores',
    procedure: 'Procedimiento realizado',
    hygiene: 'Higiene {label}',
    hygieneUnknown: 'Higiene no evaluada',
    register: 'Registrar mantenimiento',
    registerBody: 'Ingrese los datos de la activación de hoy',
    appliance: 'Tipo de aparato',
    selectAppliance: 'Seleccionar aparato…',
    upperArch: 'Arco superior',
    lowerArch: 'Arco inferior',
    select: 'Seleccionar…',
    conduct: 'Conducta / activación',
    conductPlaceholder: 'Describa ligaduras, resortes, elásticos y demás conductas…',
    oralHygiene: 'Higiene bucal del paciente',
    hygieneGroup: 'Higiene bucal del paciente',
    hygieneLine: 'Higiene {label}.',
    hygieneNone: 'No evaluada · ninguna opción seleccionada',
    note: 'Complete solo información verificada en la consulta. Los campos no tienen datos clínicos.',
    saving: 'Registrando...',
    confirm: 'Confirmar evolución',
    photos: 'Fotos de control ortodóncico',
    photosHint: 'En la pestaña Medios · filtro Fotos ortodóncicas',
    viewPhotos: 'Ver fotos y comparar antes/después',
    footer: 'Mantenga la ficha actualizada con información confirmada por el paciente y registros del profesional.',
    saved: 'Evolución ortodóncica registrada',
    saveError: 'No se pudo registrar la evolución',
    hygieneExcelente: 'Excelente',
    hygieneRegular: 'Regular',
    hygieneRuim: 'Mala'
  },
  media: {
    title: 'Medios',
    subtitle: 'Fotos, exámenes y documentos de la ficha, organizados por sección.',
    uploading: 'Enviando...',
    upload: 'Enviar archivos',
    locked: 'Los adjuntos de medios no están disponibles en el plan actual. Los archivos existentes siguen visibles.',
    filters: 'Filtros de medios',
    all: 'Todos',
    images: 'Imágenes',
    exams: 'Exámenes',
    documents: 'Documentos',
    orthoPhotos: 'Fotos ortodóncicas',
    dropOrtho: 'Arrastre fotos ortodóncicas aquí',
    dropFiles: 'Arrastre archivos aquí',
    dropOrthoHint: 'JPG o PNG · organizadas en la sección Ortodoncia',
    dropHint: 'Imágenes, PDF o MP4 · hasta 15 MB · sección {section}',
    select: 'Seleccionar',
    loading: 'Cargando medios...',
    emptySuffix: ' - ningún archivo clínico proporcionado',
    emptyOrtho: 'Ninguna foto ortodóncica',
    emptyFilter: 'Ningún medio en este filtro',
    emptyOrthoBody: 'Las fotos de control agregadas en Medios y organizadas en Ortodoncia aparecen aquí para comparar.',
    emptyFilterBody: 'Envíe fotos, exámenes o documentos para organizar la ficha.',
    compare: 'Comparar antes / después',
    base: 'Base - antes',
    overlay: 'Superpuesta - después',
    selectPhoto: 'Seleccionar foto...',
    opacity: 'Opacidad de la superpuesta',
    before: 'Antes',
    after: 'Después',
    needImage: 'Envíe al menos una imagen para visualizar.',
    pickPreview: 'Seleccione una foto para visualizar. La segunda queda superpuesta.',
    details: 'Detalles de la imagen',
    noneSelected: 'Ninguna foto seleccionada',
    section: 'Sección de organización',
    caption: 'Descripción / observación',
    captionPlaceholder: 'Contexto, fecha del registro, autorización del paciente...',
    saving: 'Guardando...',
    saveOrg: 'Guardar organización',
    noPhotoYet: 'Aún no se proporcionó ninguna foto para este paciente.',
    pickFile: 'Seleccione un archivo en la galería para editar la sección y la descripción.',
    planError: 'Los adjuntos de medios no están disponibles en este plan',
    uploadedOne: 'Archivo enviado',
    uploadedMany: '{count} archivos enviados',
    removed: 'Archivo eliminado',
    removeNamed: '¿Eliminar "{name}"?',
    removeHofPhoto: '¿Eliminar "{name}"? Esta imagen es la foto del paciente en el mapa HOF.',
    removeHofResult: '¿Eliminar "{name}"? Esta imagen es la foto de resultado del mapa HOF.',
    removeError: 'No se pudo eliminar',
    orgSaved: 'Organización guardada',
    orgError: 'No se pudo guardar la organización',
    orthoCountOne: 'foto ortodóncica',
    orthoCountMany: 'fotos ortodóncicas',
    team: 'Equipo',
    preserve: 'Conserve la autorización y el contexto de cada archivo de la ficha.',
    open: 'Abrir',
    remove: 'Quitar',
    close: 'Cerrar',
    storage: 'Almacenamiento: {used} / {quota} ({plan}/clínica)',
    orthoType: '{name}: use JPG o PNG en las fotos ortodóncicas',
    uploadFail: 'falló el envío',
    selectNamed: 'Seleccionar {name}',
    sectionClinical: 'Clínica',
    sectionExam: 'Exámenes',
    sectionDocument: 'Documentos',
    sectionOrtho: 'Ortodoncia',
    sectionHof: 'HOF'
  },
  hof: {
    sideLeft: 'Izquierdo',
    sideRight: 'Derecho',
    sideCenter: 'Central',
    sideLeftShort: 'I',
    sideRightShort: 'D',
    mark: 'Marca',
    photoAlt: 'Foto de referencia del paciente para el mapa HOF',
    anatomyAlt: 'Referencia anatómica muscular, vista frontal',
    resultsAlt: 'Foto de resultado del tratamiento',
    noneRegistered: 'Ninguna marca registrada',
    chooseBoth: 'Elija la región y el procedimiento',
    confirmRemove: '¿Quitar esta marca de la ficha?',
    needMark: 'Agregue una marca para ubicarla en el mapa',
    imageType: 'Use una imagen JPG o PNG',
    imageSize: 'La imagen supera 15 MB',
    resultSaved: 'Foto de resultado guardada en la ficha',
    photoSent: 'Foto enviada. Guarde la ficha para confirmar.',
    uploadError: 'Falló el envío de la foto',
    mapSaved: 'Mapa HOF actualizado en la ficha',
    mapError: 'No se pudo guardar el mapa HOF',
    discard: '¿Descartar los cambios no guardados del mapa HOF?',
    uploading: 'Enviando...',
    replacePhoto: 'Cambiar foto',
    selectImage: 'Seleccionar imagen',
    noPermission: 'Su perfil no permite enviar imágenes.',
    fileHint: 'JPG o PNG · hasta 15 MB',
    title: 'Armonización orofacial',
    close: 'Cerrar mapa HOF',
    history: 'Historial',
    layers: 'Capas del mapa HOF',
    zoom: 'Zoom',
    zoomOut: 'Reducir zoom',
    zoomIn: 'Aumentar zoom',
    source: 'Origen de la visualización',
    anatomy: 'Anatomía',
    patientPhoto: 'Foto del paciente',
    results: 'Resultados',
    layerFace: 'Rostro completo',
    layerFaceHint: 'Contorno y puntos de relleno / superficie',
    layerMuscles: 'Músculos',
    layerMusclesHint: 'Objetivos de toxina y anatomía muscular',
    noAnnotations: 'Ninguna anotación registrada',
    placedOne: '{count} anotación ubicada en el mapa',
    placedMany: '{count} anotaciones ubicadas en el mapa',
    unplaced: '{count} {word} · posición no confirmada en el mapa',
    annotationOne: 'anotación',
    annotationMany: 'anotaciones',
    subtitleAnatomy: 'Mapa muscular · referencia anatómica y registro de marcas',
    subtitleResults: 'Foto de resultado del tratamiento',
    subtitleResultsEmpty: 'Foto de resultado - envíe una imagen distinta de la foto del paciente',
    subtitlePhoto: 'Foto del paciente - ubique las marcas sobre la imagen',
    subtitlePhotoEmpty: 'Foto del paciente - prepare una imagen para las marcas',
    chartRecords: 'Registros HOF de la ficha',
    chartEmpty: 'Ningún registro HOF en la ficha.',
    permanentRef: 'Referencia anatómica permanente',
    illustration: 'Imagen anatómica ilustrativa · no es la foto del paciente.',
    preservedList: 'Las anotaciones se conservan en la lista, sin migración automática de puntos a los músculos.',
    states: 'Estados',
    region: 'Región',
    selectRegion: 'Seleccionar región...',
    procedure: 'Procedimiento / acción',
    selectProcedure: 'Seleccionar procedimiento...',
    notes: 'Observación',
    notesPlaceholder: 'Unidades, producto, plan, observación...',
    update: 'Actualizar',
    add: 'Agregar',
    noneMark: 'Ninguna marca',
    noneMarkBody: 'Agregue una región y el procedimiento realizado o planificado.',
    selectedInList: 'Seleccionada en la lista',
    inList: 'Marca en la lista',
    noPhotoPosition: 'Sin posición en la foto',
    repositionMap: 'Reposicionar en el mapa',
    placeMap: 'Ubicar en el mapa',
    repositionPhoto: 'Reposicionar en la foto',
    placePhoto: 'Ubicar en la foto',
    placeOnMap: '{action} {label} en el mapa',
    placeOnPhoto: '{action} {label} en la foto',
    reposition: 'Reposicionar',
    place: 'Ubicar',
    editMark: 'Editar marca',
    removeMark: 'Quitar marca',
    editNamed: 'Editar {label}',
    removeNamed: 'Quitar {label}',
    marksTitle: 'Marcas',
    preservedRecordOne: '{count} registro conservado',
    preservedRecordMany: '{count} registros conservados',
    noPhotoPositions: 'sin posiciones en la foto',
    positionedOne: '{count} ubicado en la foto',
    positionedMany: '{count} ubicados en la foto',
    stateDefault: 'Predeterminado',
    stateHighlight: 'Resaltado',
    stateSelected: 'Seleccionado',
    stateRisk: 'Zona de riesgo',
    existingOne: '{count} marca existente conservada.',
    existingMany: '{count} marcas existentes conservadas.',
    legacyMarks: 'Las marcas antiguas, incluidas las de capas discontinuadas, siguen en la lista y en la ficha.',
    anatomyDisclaimer: 'Las regiones anatómicas son referencias. Las zonas de riesgo las registra el profesional y nunca se infieren automáticamente.',
    frontView: 'VISTA FRONTAL',
    sideHint: 'D/I: lados del paciente, no del observador',
    resultsDrop: 'Envíe la foto de resultado. Queda separada de la foto del paciente.',
    photoDrop: 'Arrastre la imagen del paciente aquí o elija un archivo en el equipo.',
    photoTips: 'Prefiera una foto frontal. Rostro descubierto, cabeza alineada, luz uniforme y fondo neutro. Mantenga todo el rostro visible.',
    photoAuth: 'Use solo una imagen autorizada por el paciente para la ficha.',
    tapPhoto: 'Toque la foto para ubicar',
    tapMap: 'Toque el mapa para ubicar',
    cancel: 'Cancelar',
    placeMark: 'Ubicar marca',
    unconfirmed: ' · posición no confirmada',
    detail: 'Detalle de la marca seleccionada',
    side: 'Lado del paciente',
    recordedNote: 'Anotación registrada',
    chartHistory: 'Historial de la ficha',
    beforePlace: 'Antes de ubicar',
    beforePlaceBody: 'Las anotaciones existentes permanecen en la ficha y deben ubicarse manualmente sobre la foto del paciente.',
    unsaved: ' · cambios sin guardar',
    closeAction: 'Cerrar',
    saving: 'Guardando...',
    saveChart: 'Guardar ficha',
    team: 'Equipo'
  },
  invite: {
    loading: 'Cargando invitación...',
    invalid: 'Invitación inválida',
    notFound: 'Invitación no encontrada',
    used: 'Esta invitación ya se usó o venció',
    expired: 'Esta invitación venció',
    loadError: 'Error al cargar la invitación: {message}',
    backHome: 'Volver al inicio',
    back: 'Volver al inicio',
    invited: '¡Fuiste invitado!',
    completeNamed: 'Complete su registro para acceder al sistema de {clinic}',
    complete: 'Complete su registro para acceder al sistema',
    clinicFallback: 'Clínica',
    validUntil: 'Invitación válida hasta {date}',
    password: 'Contraseña',
    passwordRequired: 'La contraseña es obligatoria',
    passwordShort: 'La contraseña debe tener al menos 6 caracteres',
    passwordPlaceholder: 'Escriba su contraseña',
    confirm: 'Confirmar contraseña',
    confirmRequired: 'La confirmación de contraseña es obligatoria',
    mismatch: 'Las contraseñas no coinciden',
    confirmPlaceholder: 'Confirme su contraseña',
    creating: 'Creando cuenta...',
    create: 'Crear cuenta',
    created: 'Cuenta creada. Ya puede iniciar sesión.',
    createError: 'Error al crear la cuenta: {message}',
    roleAdmin: 'Administrador',
    roleProfessional: 'Profesional',
    roleSecretary: 'Secretaria'
  },
  confirmPage: {
    loading: 'Cargando cita...',
    errorTitle: 'Error',
    notFound: 'Cita no encontrada o enlace inválido',
    tokenMissing: 'Token no proporcionado',
    backHome: 'Volver al inicio',
    title: 'Confirmación de cita',
    patient: 'Paciente',
    professional: 'Profesional',
    when: 'Fecha y horario',
    procedure: 'Procedimiento',
    passed: 'El horario de esta cita ya pasó.',
    confirming: 'Confirmando...',
    confirm: 'Confirmar cita',
    cancelling: 'Cancelando...',
    cancel: 'Cancelar cita',
    confirmedOk: 'Su cita fue confirmada.',
    cancelledOk: 'Su cita fue cancelada.',
    wait: 'Lo esperamos en la fecha y horario marcados.',
    reschedule: 'Si necesita reprogramar, contáctenos.',
    alreadyConfirmed: 'Esta cita ya fue confirmada.',
    alreadyNoShow: 'Esta cita se registró como falta.',
    alreadyCancelled: 'Esta cita ya fue cancelada.',
    statusConfirmed: 'Confirmada',
    statusCancelled: 'Cancelada',
    statusNoShow: 'Faltó',
    statusPending: 'Esperando confirmación',
    statusUnknown: 'Estado desconocido',
    confirmOk: 'Cita confirmada.',
    confirmError: 'No se pudo confirmar la cita. Intente de nuevo.',
    cancelOk: 'Cita cancelada.',
    cancelError: 'No se pudo cancelar la cita. Intente de nuevo.'
  },
  clinic: {
    switched: 'Clínica cambiada a {name}',
    switchError: 'No se pudo cambiar de clínica. Intente de nuevo.',
    created: 'Clínica creada.',
    planLimit: 'El plan {plan} no incluye más clínicas.',
    createError: 'No se pudo crear la clínica. Intente de nuevo.',
    listLabel: 'Clínicas',
    plan: 'Plan',
    subscription: 'Suscripción',
    clinics: 'Clínicas',
    professionals: 'Profesionales',
    secretaries: 'Secretarias',
    storage: 'Almacenamiento',
    create: 'Crear',
    newTitle: 'Nueva clínica',
    name: 'Nombre',
    namePlaceholder: 'Nombre de la clínica',
    description: 'Descripción',
    descriptionPlaceholder: 'Ej.: Unidad principal',
    cancel: 'Cancelar',
    creating: 'Creando…'
  },
  billingReturn: {
    paidTitle: 'Pago confirmado',
    paidBody: 'La suscripción de la clínica aparece en Configuración en unos segundos.',
    cancelTitle: 'Checkout cancelado',
    cancelBody: 'No se cobró ningún valor. Puede elegir el plan de nuevo cuando quiera.',
    viewSubscription: 'Ver suscripción',
    backPlans: 'Volver a los planes',
    dashboard: 'Ir al panel'
  },
  logout: {
    closing: 'Cerrando sesión...'
  },
  quick: {
    copied: 'Mensaje de confirmación copiado',
    copyError: 'No se pudo copiar el enlace',
    whatsappOk: 'WhatsApp abierto para reenviar la confirmación',
    whatsappError: 'No se pudo preparar el reenvío',
    copy: 'Copiar',
    copyMessage: 'Copiar mensaje',
    whatsapp: 'WhatsApp',
    sendWhatsapp: 'Enviar por WhatsApp',
    edit: 'Editar',
    editAppointment: 'Editar cita'
  },
  pix: {
    copied: 'Código Pix copiado',
    copyError: 'No se pudo copiar el código',
    title: 'Pague con Pix',
    body: '{plan} · {amount}. El QR vence en hasta 48 h.',
    alt: 'Código QR Pix',
    copy: 'Copiar código Pix',
    copiedAction: 'Copiado',
    open: 'Abrir página de pago OpenPix',
    sandbox: 'Sandbox: apruebe el cobro en',
    sandboxOr: 'o con',
    autoRelease: 'La suscripción se libera automáticamente cuando se confirma el Pix.'
  },
  setup: {
    creating: 'Creando...',
    createAdmin: 'Crear administrador y continuar',
    step1: 'Paso 1: Usuario administrador',
    step1Body: 'Cree el primer usuario administrador del sistema',
    name: 'Nombre completo',
    namePlaceholder: 'Nombre del administrador',
    email: 'Correo',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    required: 'Complete todos los campos obligatorios',
    passwordShort: 'La contraseña debe tener al menos 6 caracteres',
    mismatch: 'Las contraseñas no coinciden',
    createdToast: 'Usuario administrador de la clínica creado.',
    createError: 'No se pudo crear el usuario: {message}',
    redirecting: 'Redirigiendo a la configuración de la clínica...',
    step2: 'Paso 2: Finalizar configuración',
    step2Body: 'Usuario administrador creado. Será redirigido para configurar su clínica.',
    created: 'Usuario administrador creado.',
    redirect: 'Ahora será redirigido para configurar su clínica en el onboarding.',
    back: 'Volver',
    goConfig: 'Ir a la configuración',
    fullAccess: 'Este usuario tendrá acceso total al sistema',
    afterSetup: 'Después de la configuración, podrá iniciar sesión y empezar a usar el sistema'
  }
};

export const morePages = {
  'pt-BR': morePt,
  en: moreEn,
  es: moreEs
};
